export const resolveBuildRunNumber = (buildKey: string | null | undefined): number | null => {
  if (!buildKey) return null;
  const match = /(\d+)(?!.*\d)/.exec(buildKey);
  if (!match) return null;
  const parsed = Number(match[1]);
  return Number.isFinite(parsed) ? parsed : null;
};
